import { render, staticRenderFns } from "./buynum.vue?vue&type=template&id=67e9a857&scoped=true&"
import script from "./buynum.vue?vue&type=script&lang=js&"
export * from "./buynum.vue?vue&type=script&lang=js&"
import style0 from "./buynum.vue?vue&type=style&index=0&id=67e9a857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e9a857",
  null
  
)

export default component.exports